import * as validate from "./../utils/validate-inputs";

export default function onAfterStep(callback, object) {
  if (Array.isArray(object)) {
    return Promise.all(object.map(object => onAfterStep(callback, object)));
  }

  if (!validate.physical(object)) {
    throw Error(validate.error.physical);
  }

  object.onAfterStep.add(() => callback(object));
}
